import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { Button } from 'shared-components/Button';
import { Box } from '@mui/material';
import { useTheme } from '@emotion/react';
import generateErrorPageStyles from 'styles/ErrorPageStyles';

export const NotFound = () => {
    const theme = useTheme();
    const styles = useMemo(() => generateErrorPageStyles(theme), [theme]);

    return (
        <Box sx={styles.wrapper}>
            <Box
                component="img" sx={{
                    width: 134,
                    height: 128,
                }} src="/assets/images/no-results.svg" alt="Not Found"
            />
            <Box sx={styles.title}>No Results Found</Box>
            <Box sx={styles.description}>
                Try adjusting your search or filter to find what you are looking for.
            </Box>
            <Link to="/"><Button>RETURN TO HOME SCREEN</Button></Link>
        </Box>
    );
};
